import React, { useState, useEffect } from 'react';
import { Alert } from 'reactstrap';

/**
 * Returns a human-readable relative time string from an ISO timestamp.
 */
const getRelativeTime = (isoTimestamp) => {
	if (!isoTimestamp) return null;
	const diffMs = Date.now() - new Date(isoTimestamp).getTime();
	const minutes = Math.floor(diffMs / 60000);
	const hours = Math.floor(diffMs / 3600000);
	const days = Math.floor(diffMs / 86400000);
	if (minutes < 1) return 'hace menos de un minuto';
	if (minutes === 1) return 'hace 1 minuto';
	if (minutes < 60) return `hace ${minutes} minutos`;
	if (hours === 1) return 'hace 1 hora';
	if (hours < 24) return `hace ${hours} horas`;
	if (days === 1) return 'hace 1 día';
	return `hace ${days} días`;
};

/**
 * Status bar displayed when a form draft exists.
 * Shows last-saved relative time and a discard button.
 *
 * @param {{ hasDraft: boolean, lastSaved: string|null, onDiscard: function }} props
 */
const DraftStatusBar = ({ hasDraft, lastSaved, onDiscard }) => {
	const [relativeTime, setRelativeTime] = useState(() => getRelativeTime(lastSaved));

	// Update the relative time every minute
	useEffect(() => {
		if (!hasDraft || !lastSaved) return;
		setRelativeTime(getRelativeTime(lastSaved));
		const interval = setInterval(() => {
			setRelativeTime(getRelativeTime(lastSaved));
		}, 60000);
		return () => clearInterval(interval);
	}, [hasDraft, lastSaved]);

	if (!hasDraft || !lastSaved) return null;

	return (
		<Alert color='info' className='d-flex align-items-center justify-content-between mb-3 py-2'>
			<span>
				<i className='ri-save-line me-2'></i>
				<strong>Borrador guardado</strong> {relativeTime}
			</span>
			<button
				type='button'
				className='btn btn-sm btn-outline-danger ms-3'
				onClick={onDiscard}
			>
				<i className='ri-delete-bin-line me-1'></i>
				Descartar borrador
			</button>
		</Alert>
	);
};

export default DraftStatusBar;
